module.exports = __webpack_public_path__ + "img/ng.2601661a.png";